import { ReportItem } from "@synota-io/synota-shared-ui";

export const REPORTS: ReportItem[] = [
  {
    value: "revenue",
    label: "Fulcrum Revenue",
    path: "/synota/fulcrum-revenue/csv",
  },
  {
    value: "expenses",
    label: "Fulcrum Expenses",
    path: "/synota/fulcrum-expenses/csv",
  },
  {
    value: "expenses-summary",
    label: "Expenses Summary",
    path: "/synota/fulcrum-expenses-summary/csv",
  },
];
